import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	flex-direction: column;
	gap: 32px;
`;

export const GridWrapper = styled.div`
	overflow-x: auto;
`;

export const ColorGrid = styled.div`
	display: grid;
	gap: 2px;
`;

export const HeaderCell = styled.div`
	font-size: 11px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[600]};
	text-align: center;
	padding: 4px 0 8px;
`;

export const FamilyLabel = styled.div`
	font-size: 13px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[900]};
	display: flex;
	align-items: center;
	padding-right: 12px;
	text-transform: capitalize;
	white-space: nowrap;
`;

export const SwatchCell = styled.button<{ $color: string; $selected: boolean }>`
	font: inherit;
	padding: 0;
	width: 100%;
	aspect-ratio: 1;
	min-width: 48px;
	max-width: 80px;
	background-color: ${({ $color }) => $color};
	border-radius: 8px;
	border: 2px solid
		${({ theme, $selected }) => ($selected ? theme.blue[500] : theme.gray[200])};
	position: relative;
	transition: border-color 0.15s ease, box-shadow 0.15s ease;

	&:hover {
		border-color: ${({ theme, $selected }) => ($selected ? theme.blue[500] : theme.gray[400])};
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	}
`;

export const SwatchTooltip = styled.div`
	position: absolute;
	bottom: 100%;
	left: 50%;
	transform: translateX(-50%) translateY(-6px);
	background-color: ${({ theme }) => theme.gray[900]};
	color: ${({ theme }) => theme.gray[0]};
	padding: 6px 10px;
	border-radius: 6px;
	font-size: 11px;
	font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',
		'Courier New', monospace;
	white-space: nowrap;
	pointer-events: none;
	opacity: 0;
	transition: opacity 0.15s ease;
	z-index: 10;
	text-align: center;
	line-height: 1.4;

	${SwatchCell}:hover & {
		opacity: 1;
	}

	&::after {
		content: '';
		position: absolute;
		top: 100%;
		left: 50%;
		transform: translateX(-50%);
		border: 5px solid transparent;
		border-top-color: ${({ theme }) => theme.gray[900]};
	}
`;

export const EmptyCell = styled.div`
	min-width: 48px;
	max-width: 80px;
`;

export const UngroupedSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`;

export const UngroupedHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const UngroupedTitle = styled.h4`
	font-size: 14px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[800]};
	margin: 0;
`;

export const HeaderControls = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const UngroupedGrid = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 12px;
`;

export const UngroupedSwatch = styled.button<{ $selected: boolean }>`
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 8px 12px;
	border-radius: 8px;
	border: 1px solid
		${({ theme, $selected }) => ($selected ? theme.blue[500] : theme.gray[200])};
	transition: border-color 0.15s ease;
	position: relative;
	width: 220px;
	background: transparent;
	font: inherit;
	text-align: left;

	&:hover {
		border-color: ${({ theme, $selected }) => ($selected ? theme.blue[500] : theme.gray[400])};
	}
`;

export const UngroupedSwatchColor = styled.div<{ $color: string }>`
	width: 32px;
	height: 32px;
	border-radius: 6px;
	background-color: ${({ $color }) => $color};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	flex-shrink: 0;
`;

export const UngroupedSwatchLabel = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
`;

export const UngroupedSwatchName = styled.div`
	font-size: 13px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[900]};
`;

export const UngroupedSwatchVariable = styled.div`
	font-size: 11px;
	color: ${({ theme }) => theme.gray[600]};
	font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',
		'Courier New', monospace;
`;

export const UngroupedSwatchTooltip = styled.div`
	position: absolute;
	bottom: 100%;
	left: 50%;
	transform: translateX(-50%) translateY(-6px);
	background-color: ${({ theme }) => theme.gray[900]};
	color: ${({ theme }) => theme.gray[0]};
	padding: 6px 10px;
	border-radius: 6px;
	font-size: 11px;
	font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',
		'Courier New', monospace;
	white-space: nowrap;
	pointer-events: none;
	opacity: 0;
	transition: opacity 0.15s ease;
	z-index: 10;
	text-align: center;
	line-height: 1.4;

	${UngroupedSwatch}:hover & {
		opacity: 1;
	}

	&::after {
		content: '';
		position: absolute;
		top: 100%;
		left: 50%;
		transform: translateX(-50%);
		border: 5px solid transparent;
		border-top-color: ${({ theme }) => theme.gray[900]};
	}
`;

